import React from 'react';

import {List} from '@pexip/components';

export const ReadyToJoin: React.FC<React.PropsWithChildren<unknown>> = ({
    children,
}) => <List spacing="none">{children}</List>;
